(function() {
  class TabbedContentShowcase extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.tabbed-showcase__tab');
      this.cards = this.querySelectorAll('.tabbed-showcase__card');
      this.seeMoreBtn = this.querySelector('.tabbed-showcase__see-more');
      this.seeMoreWrapper = this.querySelector('.tabbed-showcase__see-more-wrapper');
      this.itemsBeforeSeeMore = 5;
      this.currentTab = 'all';
      this.showingAll = false;
    }

    connectedCallback() {
      this.setupTabs();
      this.setupSeeMore();
      this.filterCards('all');
    }

    setupTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabValue = tab.getAttribute('data-tab');
          this.tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          this.currentTab = tabValue;
          this.showingAll = false;
          this.filterCards(tabValue);
        });
      });
    }

    setupSeeMore() {
      if (this.seeMoreBtn) {
        this.seeMoreBtn.addEventListener('click', () => {
          this.showingAll = true;
          this.filterCards(this.currentTab);
          this.seeMoreWrapper.style.display = 'none';
        });
      }
    }

    filterCards(tabValue) {
      let visibleCards = [];
      
      this.cards.forEach(card => {
        const cardTab = card.getAttribute('data-card-tab');
        card.classList.remove('visible', 'animated');
        card.style.display = 'none';
        
        if (tabValue === 'all' || cardTab === tabValue) {
          visibleCards.push(card);
        }
      });

      const cardsToShow = this.showingAll ? visibleCards : visibleCards.slice(0, this.itemsBeforeSeeMore);
      
      cardsToShow.forEach((card, index) => {
        card.classList.add('visible');
        setTimeout(() => {
          card.classList.add('animated');
        }, index * 100);
      });

      if (visibleCards.length > this.itemsBeforeSeeMore && !this.showingAll) {
        this.seeMoreWrapper.classList.add('visible');
      } else {
        this.seeMoreWrapper.classList.remove('visible');
      }
    }
  }

  // Only define the custom element if it hasn't been defined yet to prevent errors
  if (!customElements.get('tabbed-content-showcase')) {
    customElements.define('tabbed-content-showcase', TabbedContentShowcase);
  }
})();